<app-header></app-header>

<ion-content scrollbar>
  <div *ngIf="!p.renderMobile" class="breadcrumb-bottom-margin">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <ion-grid *ngIf="!p.renderMobile">
    <div class="sb-container">
      <ion-button
        routerLink="/app/report/report-config/add-report-config"
        size="medium"
      >
        <ion-icon name="add" slot="start"></ion-icon>
        <ion-label>
          {{'REPORT_CONFIG.ADD_REPORT_CONFIG' | translate}}</ion-label
        >
      </ion-button>
    </div>
  </ion-grid>

  <ion-fab
    *ngIf="p.renderMobile"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
  >
    <ion-fab-button routerLink="/app/report/report-config/add-report-config">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <app-pagination-client-side
    [columns]="columnsDefinition"
    [componentRef]="componentRef"
    (rowsLoaderReady)="rowsLoaderServiceReady($event)"
    (refreshRequest)="refreshReportConfigs()"
  >
  </app-pagination-client-side>
</ion-content>
